import { SUPPORTED_FILE_FORMATS } from './constants';

export const SupportedFormatsTooltip: React.FC = () => {
  return (
    <div className="dashboard-modal__attachments__formats-tooltip">
      <h3 className="dashboard-modal__attachments__formats-tooltip-title">
        Supported Formats
      </h3>

      <div className="dashboard-modal__attachments__formats-tooltip-list">
        {SUPPORTED_FILE_FORMATS.map(({ category, formats }) => (
          <div
            key={category}
            className="dashboard-modal__attachments__formats-tooltip-row"
          >
            <span className="dashboard-modal__attachments__formats-tooltip-category">
              {category}
            </span>

            <span className="dashboard-modal__attachments__formats-tooltip-values">
              {formats}
            </span>
          </div>
        ))}
      </div>

      <p className="dashboard-modal__attachments__formats-tooltip-note">
        Executable files (e.g. .exe, .bat, .apk etc.) are not supported for
        security reasons.
      </p>
    </div>
  );
};
